<template>
  <div class="sortlist">
    <transition name="sideUp">
      <div class="content" ref="content" v-show="this.$store.getters.getSortShow">
        <div class="content-type">
          <div class="typelist" :class="{'bottom-line' : (index !== menuList.content.length-1)}" v-for="(item, index) in menuList.content" @click="clickItem(item)" >
            <i class="info icon-check" v-show="(isCurrentSort === item.action) && (isCurrentOrderBy === item.type)"></i>
            <div class="typelist-detail">
              <span class="name">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="menu-cancel" @click.stop="hideMenuList">取消</div>
      </div>
    </transition>
    <transition name="fade">
      <div class="mask" v-show="this.$store.getters.getSortShow" @click="hideMenuList" @touchmove.stop.prevent="stopTouch($event)">
      </div>
    </transition>
  </div>
</template>

<script>
  import store from '../../store/index'
  import typelist from './menu_item.vue'
  export default {
    data () {
      return {
        isShow: false,
        allMenu: {
        }
      }
    },
    methods: {
      stopTouch (event) {
        return
      },
      clickItem (obj) {
        console.log(obj.action + '===sortList==' + obj.type)
        store.dispatch({
          type: 'set_Sort',
          param: {
            sort: obj.action,
            orderBy: obj.type
          }
        })
        store.commit('setIsReloadFilelist', true)
        this.hideMenuList()
      },
      hideMenuList () {
        store.dispatch({
          type: 'hideSortList'
        })
      }
    },
    computed: {
      menuList () {
        return this.$store.getters.getSortInfo
      },
      isCurrentSort () {
        return this.$store.getters.getCurrentFolderSort
      },
      isCurrentOrderBy () {
        return this.$store.getters.getCurrentFolderOrderBy
      }
    },
    watch: {
      isShow: function (newisShow) {
        if (newisShow) {
          // this.$refs.content.style.height = `${this.$store.getters.getShowMenuInfo.content.length * 50 + 20}px`
        }
      }
    },
    components: {
      'type-list': typelist
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/global.styl"
  .sortlist
    font-size: 0.4rem
    .content
      position: fixed
      z-index: 16
      height: auto
      bottom: 0
      left: 0
      right: 0
      margin:  .26rem
      &.sideUp-enter-to, &.sideUp-leave-to
        transition: transform 0.3s
      &.sideUp-enter, &.sideUp-leave-to
        transform: translate3d(0, 100%, 0)
      .content-type
        height: 9.12rem
        width: 100%
        border-radius: .32rem
        background: #FCFCFC
        .typelist
          text-align: center
          height: 1.52rem
          line-height: 1.52rem
          &.bottom-line
            border-bottom: 1px solid $split_color_fat
          .icon-check
            font-size: 0.67rem
            line-height: 1.52rem
          .name
            color:$primarycolor
      .menu-cancel
        color: $primarycolor
        border-radius: 0 0 .32rem .32rem
        width: 100%
        height: 1.52rem
        font-size: .45rem
        background #fff
        margin-top: .24rem
        border-radius: .32rem
        line-height: 1.52rem
        text-align: center
</style>



// WEBPACK FOOTER //
// menu_sort.vue?16890679